/*
  WAENN — Reordena los 3 botones nativos del banner de cookies de Shopify
  (#shopify-pc__banner) en una sola fila (o columna en movil) legible.

  Por que un script y no solo CSS: Shopify inyecta este banner via
  content_for_header con un wrapper de botones que no es fiable via CSS
  puro (varia entre tiendas y no esta documentado). En vez de adivinar el
  selector, este script busca los 3 botones reales por su id/clase fija
  (esos si son estables y documentados por Shopify) y los mueve a una fila
  propia que creamos nosotros, en el orden Administrar / Rechazar / Aceptar.
  El aspecto visual (glass, radios, colores) vive en
  assets/waenn-overrides.css.

  HISTORIAL DE LA CAUSA RAIZ REAL DEL BUG EN MOVIL (18/09), confirmada con
  datos reales del movil de WAENN via un diagnostico temporal (ya
  retirado -- cumplio su proposito y se quito del todo):

  1) La clase "shopify-pc__banner__dialog" esta en el propio
     <section id="shopify-pc__banner" class="shopify-pc__banner__dialog">,
     no en un hijo -- `banner.querySelector('.shopify-pc__banner__dialog')`
     nunca la habria encontrado ahi (solo busca descendientes). FIX: si el
     banner ya lleva esa clase, se usa el banner mismo como destino de la
     fila de botones, evitando el `.shopify-pc__banner__wrapper` de
     Shopify (pensado solo para sus 2 hijos originales) por completo.
  2) En movil, la regla que apila los 3 botones en columna usaba
     `flex: 1 1 0 !important`. En un contenedor flex en columna, el
     "flex-basis" (el "0" de esa declaracion) tiene prioridad sobre la
     propiedad "height" a la hora de calcular el tamano de partida de
     cada boton -- y con overflow:hidden en los botones, la especificacion
     de flexbox fija ademas su "tamano minimo automatico" en 0. Resultado:
     los 3 botones colapsaban a 0-2px de alto pese a tener
     "height: 44px !important" en la misma regla. Arreglado en
     assets/waenn-overrides.css usando `flex: none` + altura fija en vez
     de flex-grow para el apilado en movil.

  Con ambas causas resueltas, el banner se muestra una unica vez, con sus
  3 acciones visibles y pulsables, sin abrir ningun modal nativo
  adicional salvo que el usuario pulse explicitamente "Administrar
  preferencias".
*/
(function () {
  function findByRole(banner, exactSelector, substring) {
    var el = banner.querySelector(exactSelector);
    if (el) return el;

    // Red de seguridad: busca entre TODOS los botones/enlaces del banner
    // uno cuyo atributo class contenga la subcadena esperada (p.ej.
    // "accept"), por si Shopify cambia el nombre exacto de la clase o
    // anade prefijos/sufijos.
    var candidates = banner.querySelectorAll('button, a');
    for (var i = 0; i < candidates.length; i++) {
      var cls = (candidates[i].getAttribute('class') || '').toLowerCase();
      var id = (candidates[i].getAttribute('id') || '').toLowerCase();
      if (cls.indexOf(substring) !== -1 || id.indexOf(substring) !== -1) {
        return candidates[i];
      }
    }
    return null;
  }

  function styleShopifyCookieBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.getAttribute('data-waenn-styled') === '1') return;

    // Si el propio banner YA lleva la clase dialog (caso real de
    // WAENN: <section id="shopify-pc__banner"
    // class="shopify-pc__banner__dialog">), usamos el banner en si como
    // destino -- querySelector() nunca la habria encontrado ahi porque
    // solo busca descendientes, nunca el propio elemento de partida.
    var dialog = banner.classList.contains('shopify-pc__banner__dialog')
      ? banner
      : banner.querySelector('.shopify-pc__banner__dialog') || banner.firstElementChild || banner;

    var acceptBtn = findByRole(
      banner,
      '#shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-accept',
      'accept'
    );
    var declineBtn = findByRole(
      banner,
      '#shopify-pc__banner__btn-decline, .shopify-pc__banner__btn-decline',
      'decline'
    );
    var manageBtn = findByRole(
      banner,
      '#shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs',
      'manage'
    );

    // Si ni siquiera con la busqueda por subcadena aparece un boton de
    // aceptar, no forzamos nada: mejor dejar el banner nativo de Shopify
    // tal cual (siempre visible/clicable con sus propios estilos) que
    // dejarlo a medio-transformar. La red de seguridad de CSS en
    // waenn-overrides.css sigue dando color/fondo visibles a cualquier
    // boton/enlace del dialogo aunque este script no llegue a reordenar.
    if (!acceptBtn) return;

    banner.setAttribute('data-waenn-styled', '1');

    var row = document.createElement('div');
    row.setAttribute('data-waenn-cookie-row', '1');

    [manageBtn, declineBtn, acceptBtn].forEach(function (btn) {
      if (btn) row.appendChild(btn);
    });

    dialog.appendChild(row);
  }

  // Si Shopify vuelve a abrir su propio modal nativo de "Preferencias de
  // cookies y privacidad" (el que dispara el boton de "gestionar
  // preferencias" cuando se pulsa), aqui NO se toca ni se oculta ese
  // modal -- es el modal real de ajustes detallados de Shopify y debe
  // poder abrirse cuando el usuario pulsa explicitamente
  // "Administrar"/"Gestionar preferencias". Con el banner principal
  // siempre visible y sus 3 botones claramente diferenciados y del
  // tamano correcto, ese modal solo se abre cuando de verdad se pulsa esa
  // opcion, no por accidente.

  var observer = new MutationObserver(styleShopifyCookieBanner);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  styleShopifyCookieBanner();
})();
